import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { BooksAutocomplete, Form } from "@shared/components";

export const AudioFileListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("v1/audiobook_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <BooksAutocomplete
          name="book"
          label={translate("v1/audiobook_admin.fields.book")}
          labelField="title"
          queryHookFilters={{ type: "audiobook" }}
          required
        />
      </Grid>
    </Grid>
  );
});
